import type { ScreenModule } from "../../../app/screen-module";
import { ProjectDetailPage } from "../WorkspacePages";

export default {
	id: "end-user.project-detail",
	path: "/app/projects/:projectId",
	area: "end-user",
	label: "プロジェクト詳細",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: ProjectDetailPage,
} satisfies ScreenModule;
